module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_pause-d28064be7b71063302bb888f32ac0d13.svg";